import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { Form, Spinner } from 'react-bootstrap';

import { Button } from '../../Atoms/Button';

import Channels from './Channels';
import { poweredDownPortsProps, switchDataProps } from './propTypes';

const PortConfiguration = ({
  activeLayoutId,
  poweredDownPorts,
  noInternetPorts,
  switchData,
  portStatus,
  children,
  onUpdate,
  loading,
  isEditing = false,
  readonly = false,
  editOptions = {
    border: true,
    buttons: true,
    triggerSave: 0,
  },
}) => {
  const [editing, setEditing] = useState(isEditing);
  const onInnerSubmit = (values) => onUpdate(values);
  const { border, buttons, triggerSave } = editOptions;

  useEffect(() => {
    setEditing(isEditing);
  }, [isEditing]);

  const formRef = useRef();
  useEffect(() => {
    if (triggerSave) {
      formRef.current.handleSubmit();
    }
  }, [triggerSave]);

  return (
    <Formik
      innerRef={formRef}
      initialValues={{
        selected_layout: +activeLayoutId,
        port1_status: !poweredDownPorts.includes(1),
        port2_status: !poweredDownPorts.includes(2),
        port3_status: !poweredDownPorts.includes(3),
        port4_status: !poweredDownPorts.includes(4),
      }}
      enableReinitialize
      onSubmit={onInnerSubmit}
    >
      {({
        isValid,
        isSubmitting,
        dirty,
        handleSubmit,
        values,
        setFieldValue,
      }) => {
        const submitDisabled = !!(!isValid || isSubmitting || !dirty);
        if (!switchData.find((data) => data.id === values.selected_layout)) {
          setFieldValue('selected_layout', activeLayoutId);
        }
        return (
          <Form onSubmit={handleSubmit} noValidate>
            <div
              className={border && editing ? 'border border-success p-3' : ''}
            >
              <fieldset disabled={loading}>
                <Channels
                  editing={editing}
                  switchData={switchData}
                  portStatus={portStatus}
                  poweredDownPorts={poweredDownPorts}
                  noInternetPorts={noInternetPorts}
                  activeLayoutId={+activeLayoutId}
                >
                  {children}
                </Channels>
                <div className="mt-3">
                  {buttons && editing ? (
                    <div className="d-flex justify-content-center">
                      <Button
                        variant="link"
                        className="mr-1"
                        onClick={() => setEditing(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant={submitDisabled ? 'secondary' : 'success'}
                        disabled={submitDisabled}
                        type="submit"
                        className="ml-1"
                      >
                        {isSubmitting && (
                          <Spinner
                            animation="border"
                            size="sm"
                            className="mr-1"
                          />
                        )}{' '}
                        Save
                      </Button>
                    </div>
                  ) : (
                    !readonly &&
                    buttons && (
                      <Button onClick={() => setEditing(!editing)}>Edit</Button>
                    )
                  )}
                </div>
              </fieldset>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

PortConfiguration.propTypes = {
  noInternetPorts: poweredDownPortsProps,
  poweredDownPorts: poweredDownPortsProps,
  activeLayoutId: PropTypes.number.isRequired,
  switchData: switchDataProps,
  portStatus: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
  onUpdate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  isEditing: PropTypes.bool,
  readonly: PropTypes.bool,
  editOptions: PropTypes.shape({
    border: PropTypes.bool,
    buttons: PropTypes.bool,
    triggerSave: PropTypes.number,
  }),
};

export default PortConfiguration;
